import { Divider } from 'antd'
import { AvatarDummy, NoImage } from 'assets'
import useAuth from 'hooks/useAuth'
import React from 'react'
import { FaCamera } from 'react-icons/fa'
import { PiSealCheckFill } from 'react-icons/pi'
import { NavLink } from 'react-router-dom'
import { useState, useRef, useId } from 'react'
import { useMutation, useQuery } from 'react-query'
import { getAccountInformation, changeProfileImage, postPublicFile } from 'api'
import { showErrorMessage } from 'utils'
import { getErrorMessage } from 'utils/getErrorMessage'
import { store } from 'store'

// Path yang seharusnya membuat "Profil Saya" aktif
const profilePaths = [
  '/profile',
  '/profile/account-information',
  '/profile/change-password',
  '/profile/advisor-information'
]

// Path yang harus membuat "Profil Saya" non-aktif
const excludeProfilePaths = [
  '/profile/transaction',
  '/profile/transaction/detail-transaction',
  '/profile/sales',
  '/profile/purchase',
  '/profile/valuation',
  '/profile/membership',
  '/profile/search-agent',
  '/profile/favorite',
  '/profile/message',
  '/profile/events'
]
const profileNavList = [
  {
    name: 'Profil Saya',
    route: '/profile'
  },
  {
    name: 'Pesan',
    route: '/profile/message'
  },
  {
    name: 'Transaksi',
    route: '/profile/transaction'
  },
  // {
  //   name: 'Penjualan',
  //   route: '/profile/sales'
  // },
  // {
  //   name: 'Pembelian',
  //   route: '/profile/purchase'
  // },
  // {
  //   name: 'Penilaian',
  //   route: '/profile/valuation'
  // },
  {
    name: 'Keanggotaan',
    route: '/profile/membership'
  },
  {
    name: 'Agen Pencarian',
    route: '/profile/search-agent'
  },
  {
    name: 'Favorit',
    route: '/profile/favorite'
  },
  {
    name: 'Events',
    route: '/profile/events'
  },
  {
    name: 'Webinars',
    route: '/profile/webinars'
  }
]
const ProfileSidebar = () => {
  const token = store.getState().auth.access_token
  const { onLogout, userProfile, setProfileUser } = useAuth()

  const [urlEdit, setUrlEdit] = useState(null)
  const defaultId = useId()
  const inputRef = useRef()

  const postUploadFile = useMutation({
    mutationKey: 'postUploadFileImage',
    mutationFn: (payload) => postPublicFile(payload),
    onSuccess: (data) => {
      const params = { photo_profile: data.filepath }
      changeImageProfile.mutate(params)
    },
    onError: (err) => {
      showErrorMessage(getErrorMessage(err))
    }
  })

  const changeImageProfile = useMutation({
    mutationKey: 'changeProfileImage',
    mutationFn: (payload) => changeProfileImage(payload),
    onSuccess: ({ data }) => {
      getAccountInformationQuery.refetch()
    },
    onError: (err) => {
      showErrorMessage(getErrorMessage(err))
    }
  })

  const getAccountInformationQuery = useQuery({
    queryKey: 'getAccountInformationQuery',
    queryFn: () => getAccountInformation(token),
    onSuccess: ({ data }) => {
      setProfileUser(data)
    },
    onError: () => {},
    enabled: false
  })

  return (
    <div className="flex flex-col gap-4 justify-center items-center">
      {/* Avatar */}
      <div className="px-4 py-8 border border-lighter border-solid rounded-lg flex flex-col gap-4 justify-center items-center w-full">
        <div className="rounded-full flex justify-center items-center relative mx-auto ">
          <img
            src={
              urlEdit
                ? urlEdit
                : userProfile?.tmp_photo_profile
                ? userProfile?.tmp_photo_profile
                : userProfile?.photo_profile || NoImage
            }
            alt={'Profile Image'}
            className="object-center object-cover w-20 h-20 rounded-full"
          />
          <div
            onClick={() => inputRef.current.click()}
            className="absolute right-0 bottom-0 translate-x-[25%] w-10 h-10 p-2 rounded-full border-4 border-solid border-white bg-surface-brand-2">
            <FaCamera className="fill-white" />
          </div>
        </div>
        <div className="flex flex-col gap-4">
          {/* Name & Account */}
          <div className="flex flex-col gap-1 justify-center items-center">
            <p className=" font-medium flex justify-center items-center gap-1">
              {userProfile?.name}{' '}
              {userProfile?.package_subscriptions?.length > 0 ? (
                <PiSealCheckFill className="fill-brand-default" size={16} />
              ) : null}
            </p>
            <span className="text-xs text-secondary font-medium">
              {userProfile?.user_type === 'PAID' ? 'Akun Member' : 'Akun Gratis'}
            </span>
          </div>
        </div>
      </div>
      {/* Profile Nav */}
      <div className="px-4 py-6 border border-lighter border-solid rounded-lg flex flex-col gap-3 w-full">
        <ul className="list-none px-4 flex flex-col gap-3 w-full">
          {profileNavList.map((item, index) => {
            let isActive = location.pathname === item.route

            // Cek apakah ini menu "Profil Saya"
            if (item.route === '/profile') {
              isActive = profilePaths.some((path) => location.pathname.startsWith(path))

              // Jika sedang di salah satu path yang tidak boleh membuat "Profil Saya" aktif, paksa isActive = false
              if (excludeProfilePaths.some((path) => location.pathname.startsWith(path))) {
                isActive = false
              }
            }

            return (
              <li key={index}>
                <NavLink
                  className={() =>
                    `${
                      isActive ? 'text-brand-default' : 'text-primary'
                    } no-underline text-sm cursor-pointer w-fit hover:text-brand-default font-medium`
                  }
                  to={item.route}>
                  {item.name}
                </NavLink>
              </li>
            )
          })}
        </ul>
        <Divider
          variant="solid"
          className="m-0 border-solid border-t-0 border-[1.5px] border-lighter"
        />
        <span
          className="text-primary px-4 text-sm cursor-pointer w-fit hover:text-brand-default font-medium"
          onClick={onLogout}>
          Keluar
        </span>
      </div>
      <input
        accept=".png,.jpg,.jpeg"
        className="hidden"
        id={defaultId}
        multiple={false}
        onChange={(e) => {
          setUrlEdit(URL.createObjectURL(e.target.files[0]))
          let formData = new FormData()
          formData.append('upload', e.target.files[0])
          formData.append('path', 'public/user/photo-profile')
          postUploadFile.mutate(formData)
        }}
        ref={inputRef}
        type="file"
      />
    </div>
  )
}

export default ProfileSidebar
